import {
  IAddScheduleOverride,
  IBulkUpsertWorkingHours,
  ICloseRestaurantNow,
  IRestaurantAvailability,
  IScheduleOverride,
} from "../models/IAvailability";
import { IWorkingHour } from "../../models/IWorkingHour";
import { configWithUserToken } from "../../services/config";

/* ------------------------- Açık / kapalı durumu ------------------------- */

export const getAvailability = (restaurantId: string) =>
  configWithUserToken.get<IRestaurantAvailability>(`RestaurantAvailability/${restaurantId}`);

export const closeRestaurantNow = (payload: ICloseRestaurantNow) =>
  configWithUserToken.post<IRestaurantAvailability>("RestaurantAvailability/close", payload);

export const reopenRestaurant = (restaurantId: string) =>
  configWithUserToken.post<IRestaurantAvailability>("RestaurantAvailability/reopen", { restourantId: restaurantId });

/* ------------------------- İleri tarihli istisnalar ------------------------- */

export const getOverrides = (restaurantId: string) =>
  configWithUserToken.get<IScheduleOverride[]>(`RestaurantAvailability/${restaurantId}/overrides`);

export const addOverride = (payload: IAddScheduleOverride) =>
  configWithUserToken.post<IScheduleOverride>("RestaurantAvailability/overrides", payload);

export const cancelOverride = (overrideId: string) =>
  configWithUserToken.delete(`RestaurantAvailability/overrides/${overrideId}`);

/* ------------------------- Haftalık program ------------------------- */

export const deleteWorkingHour = (id: string) =>
  configWithUserToken.delete(`RestaurantWorkingHours/${id}`);

export const bulkUpsertWorkingHours = (payload: IBulkUpsertWorkingHours) =>
  configWithUserToken.post<IWorkingHour[]>("RestaurantWorkingHours/bulk-upsert", payload);
